module.exports = {
    RA_SUITABILITY_TEST_UPDATE_ZERO_QUESTION:
        'RA_SUITABILITY_TEST_UPDATE_ZERO_QUESTION',
    RA_ERROR_FETCHING_COUNTRY_OF_RESIDENCE_MODAL_CLOSE:
        'RA_ERROR_FETCHING_COUNTRY_OF_RESIDENCE_MODAL_CLOSE',
    RA_SUITABILITY_TEST_SIGN_TEST_SUCCESS:
        'RA_SUITABILITY_TEST_SIGN_TEST_SUCCESS',
};
